import { ContactForm } from "../../../components";
import { useTranslation } from "react-i18next";

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className="w-full py-8 px-4 text-center text-white bg-gradient-to-b from-[#F00D0D] to-[#994F4F]">
        <h1 className="text-[32px] font-bold mb-2">{t("contact.title")}</h1>
        <p className="text-[22px] font-bold">{t("contact.subtitle")}</p>
      </div>

      <div className="max-w-7xl mx-auto p-6">
        <div className="w-full grid lg:grid-cols-2 gap-8">
          <ContactForm />

          <div>
            <iframe
              title="map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d839.2789244560826!2d-97.12270382419831!3d32.70955319411621!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x864e7d3a43e0bb81%3A0x7d5801f399210976!2s1117%20W%20Pioneer%20Pkwy%2C%20Arlington%2C%20TX%2076013%2C%20Hoa%20K%E1%BB%B3!5e0!3m2!1svi!2s!4v1747045730679!5m2!1svi!2s"
              width="100%"
              height="450"
              style={{
                border: 0,
              }}
              allowFullScreen={false}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
